/* eslint-disable react/no-danger */
import React from 'react'
import PropTypes from 'prop-types'
import { variables } from '@resurs/midas'
import styles from '../chat.style'
import { getSanitizedHTML } from '../../../util/helpers'

export const ChatBubble = props => {
  const bubble = { ...styles.bubble }
  if (props.fromMe) {
    bubble.background = variables.coreColor
    bubble.color = '#fff'
  } else {
    bubble.background = '#eee'
    bubble.color = '#000'
  }

  const getText = () => {
    if (typeof props.text === 'string' || props.text instanceof String) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: getSanitizedHTML(props.text),
          }}
        />
      )
    }
    return props.text
  }

  return (
    <div style={bubble}>
      <span style={styles.timeStamp}>{props.timeStamp}</span>
      <span>{getText()}</span>
    </div>
  )
}

ChatBubble.propTypes = {
  text: PropTypes.any.isRequired,
  fromMe: PropTypes.bool.isRequired,
  timeStamp: PropTypes.string,
}

ChatBubble.defaultProps = {
  timeStamp: null,
}
